import { render } from "./DailyContent.vue?vue&type=template&id=3a5c3167&scoped=true"
import script from "./DailyContent.vue?vue&type=script&lang=js"
export * from "./DailyContent.vue?vue&type=script&lang=js"

import "./DailyContent.vue?vue&type=style&index=0&id=3a5c3167&lang=scss&scoped=true"

import exportComponent from "D:\\code\\newspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5c3167"]])

export default __exports__